import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Only reuse pages if the parameters stay the same (same entities).
 */
@Injectable()
export class ParamAwareRouteReuseStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot
  ): boolean {
    if (future.routeConfig !== current.routeConfig) return false;

    const futureParams = Object.entries(future.params);
    return (
      futureParams.length === Object.keys(current.params).length &&
      futureParams.every(([key, value]) => current.params[key] === value)
    );
  }
}
